import { getBaseMetaTitle } from '@/environments'

const Gallery = () => import('./Main')

const route = {
  path: '/gallery',
  name: 'gallery',
  meta: {
    title: `Gallery - ${getBaseMetaTitle}`
  },
  component: Gallery
}

export default route
